import { useParams } from 'react-router-dom'
import { PageContentQuickReorder, PageContentReorderProducts } from '@restaurant/core'
import { useWebReorderPageViewModel } from '../viewmodels/pages/WebReorderPageViewModel'

export default function ReorderPage() {
  const { orderId } = useParams<{ orderId?: string }>()
  const viewModel = useWebReorderPageViewModel()

  if (orderId) {
    const pageProps = viewModel.getSingleOrderReorderProps(orderId)
    return (
      <PageContentReorderProducts
        {...pageProps}
        testID="reorder-single-page"
        accessibilityLabel="Reorder items from a previous order"
      />
    )
  }

  const pageProps = viewModel.getQuickReorderProps()
  return (
    <PageContentQuickReorder
      {...pageProps}
      testID="reorder-page"
      accessibilityLabel="Quick reorder from past orders"
    />
  )
}
